import React, { useState } from 'react';

const navLinks = [
    { text: 'About', href: '#header' },
    { text: 'Experience', href: '#experience' },
    { text: 'Projects', href: '#projects' },
    { text: 'Contact Me', href: '#contact' },
];

const NavLink = ({ text, href }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isActive, setIsActive] = useState(false);

    const scale = isActive ? 0.9 : isHovered ? 1.1 : 1;

    const handleClick = (e) => {
        e.preventDefault();
        const targetSection = document.querySelector(href);
        if (targetSection) {
            const offsetTop = targetSection.offsetTop + (targetSection.offsetHeight / 2) - (window.innerHeight / 2);
            window.scrollTo({
                top: offsetTop,
                behavior: 'smooth'
            });
        }
    };

    return (
        <a
            href={href}
            onClick={handleClick}
            style={{
                color: '#fff',
                textDecoration: 'none',
                fontWeight: 'bold',
                transform: `scale(${scale})`,
                transition: 'transform 0.2s ease-in-out',
                display: 'inline-block',
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => {
                setIsHovered(false);
                setIsActive(false);
            }}
            onMouseDown={() => setIsActive(true)}
            onMouseUp={() => setIsActive(false)}
        >
            {text}
        </a>
    );
};

const Navbar = () => (
    <nav style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '1.5rem 2rem', background: '#000', color: '#fff', position: 'sticky', top: 0, zIndex: 100 }}>
        <ul style={{ display: 'flex', listStyle: 'none', gap: '3rem', margin: 0, padding: 0 }}>
            {navLinks.map(link => (
                <li key={link.text}>
                    <NavLink text={link.text} href={link.href} />
                </li>
            ))}
        </ul>
    </nav>
);

export default Navbar; 